export default __webpack_public_path__ + "static/char-s-59-zh-Hant-e7068f1b4cda726ef2c4a2521ea3f999.webp";